import React from 'react';
import { AppList } from "components/list/AppList";

import { Datagrid, TextField, SelectField } from 'react-admin';

import { LongTextField } from '../../../components/fields/LongTextField';
import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import { AdminActionsFilter } from './ListFilters';
import { AdminActionName } from 'entities/AdminActionName';
import { DateTimeField } from 'components/fields/DateFormatField';
import { useEnumSelectChoices } from 'components/_helpers/useEnumSelectChoices';


const defaultSort = { field: 'id', order: 'DESC' };

export const AdminActionsList = props => {	
	const adminActionChoices = useEnumSelectChoices(AdminActionName, '', false);

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<AdminActionsFilter />}
		>
			<ScrollingWrapper>
				<Datagrid
					rowClick='show'
				>
					<TextField source='id' />
					<SelectField source='name' choices={adminActionChoices} />
					<DateTimeField source='created_at' withLocalTimeZone />
					<LongTextField source='data' sortable={false} />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
